import api from "../services/backendServices";

const model = {
  state: {
    retrieved: [],
    loading: false,
    error: null,
    filters: {
      fecha: null,
      centroId: null,
      search: "",
    },
  },
  reducers: {
    setRetrieved(state, retrieved) {
      return Object.assign({}, { ...state, retrieved });
    },
    setLoading(state, loading) {
      return Object.assign({}, { ...state, loading });
    },
    setError(state, error) {
      return Object.assign({}, { ...state, error });
    },
    setFilters(state, filters) {
      return Object.assign({}, { ...state, filters: { ...state.filters, ...filters } });
    },
    reset(state) {
      return {
        retrieved: [],
        loading: false,
        error: null,
        filters: {
          fecha: null,
          centroId: null,
          search: "",
        },
      };
    },
  },
  effects: (dispatch) => ({
    async list(payload, state) {
      return new Promise((resolve, reject) => {
        this.setLoading(true);
        this.setError(null);

        // Mock data por ahora
        const mockData = [
          {
            id: 1,
            hora: "08:00",
            matriculado: "Juan Pérez",
            servicio: "Consulta general",
            estado: "pendiente",
            centroId: payload?.centroId || 1,
            fecha: payload?.fecha || new Date().toISOString().split("T")[0],
          },
          {
            id: 2,
            hora: "08:15",
            matriculado: "Lucía Fernández",
            servicio: "Vacunación",
            estado: "pendiente",
            centroId: payload?.centroId || 1,
            fecha: payload?.fecha || new Date().toISOString().split("T")[0],
          },
          {
            id: 3,
            hora: "08:30",
            matriculado: "Pedro Gómez",
            servicio: "Trámite",
            estado: "atendido",
            centroId: payload?.centroId || 1,
            fecha: payload?.fecha || new Date().toISOString().split("T")[0],
          },
          {
            id: 4,
            hora: "08:45",
            matriculado: null,
            servicio: null,
            estado: "libre",
            centroId: payload?.centroId || 1,
            fecha: payload?.fecha || new Date().toISOString().split("T")[0],
          },
          {
            id: 5,
            hora: "09:00",
            matriculado: "Ana Ruiz",
            servicio: "Control",
            estado: "atendido",
            centroId: payload?.centroId || 1,
            fecha: payload?.fecha || new Date().toISOString().split("T")[0],
          },
          {
            id: 6,
            hora: "09:15",
            matriculado: "Carlos Díaz",
            servicio: "Consulta general",
            estado: "no-asistio",
            centroId: payload?.centroId || 1,
            fecha: payload?.fecha || new Date().toISOString().split("T")[0],
          },
          {
            id: 7,
            hora: "09:30",
            matriculado: null,
            servicio: null,
            estado: "libre",
            centroId: payload?.centroId || 1,
            fecha: payload?.fecha || new Date().toISOString().split("T")[0],
          },
          {
            id: 8,
            hora: "09:45",
            matriculado: "María López",
            servicio: "Vacunación",
            estado: "pendiente",
            centroId: payload?.centroId || 1,
            fecha: payload?.fecha || new Date().toISOString().split("T")[0],
          },
        ];

        // Simular delay de API
        setTimeout(() => {
          this.setLoading(false);
          this.setRetrieved(mockData);
          resolve(mockData);
        }, 500);

        // Cuando se conecte el backend, usar:
        // api.WorkflowServices.getAgendaDia(payload?.fecha, payload?.centroId)
        //   .then((response) => {
        //     this.setLoading(false);
        //     this.setRetrieved(response.data);
        //     resolve(response.data);
        //   })
        //   .catch((error) => {
        //     this.setLoading(false);
        //     this.setError(error.message);
        //     reject(error);
        //   });
      });
    },
    async markAttendance(payload, state) {
      return new Promise((resolve, reject) => {
        this.setLoading(true);
        this.setError(null);

        // Mock: actualizar estado local
        const updated = state.agenda.retrieved.map((turno) =>
          turno.id === payload.turnoId
            ? { ...turno, estado: "atendido" }
            : turno
        );

        setTimeout(() => {
          this.setLoading(false);
          this.setRetrieved(updated);
          resolve(updated);
        }, 300);

        // Cuando se conecte el backend:
        // api.WorkflowServices.markAttendance(payload.turnoId)
        //   .then((response) => {
        //     this.setLoading(false);
        //     this.list({ fecha: state.agenda.filters.fecha, centroId: state.agenda.filters.centroId });
        //     resolve(response.data);
        //   })
        //   .catch((error) => {
        //     this.setLoading(false);
        //     this.setError(error.message);
        //     reject(error);
        //   });
      });
    },
    async reschedule(payload, state) {
      return new Promise((resolve, reject) => {
        this.setLoading(true);
        this.setError(null);

        setTimeout(() => {
          this.setLoading(false);
          this.list({ fecha: state.agenda.filters.fecha, centroId: state.agenda.filters.centroId });
          resolve({ success: true });
        }, 300);

        // Cuando se conecte el backend:
        // api.WorkflowServices.reschedule(payload.turnoId, payload.nuevaFecha)
        //   .then((response) => {
        //     this.setLoading(false);
        //     this.list({ fecha: state.agenda.filters.fecha, centroId: state.agenda.filters.centroId });
        //     resolve(response.data);
        //   })
        //   .catch((error) => {
        //     this.setLoading(false);
        //     this.setError(error.message);
        //     reject(error);
        //   });
      });
    },
    async reserve(payload, state) {
      return new Promise((resolve, reject) => {
        this.setLoading(true);
        this.setError(null);

        // Mock: actualizar turno libre con datos
        const updated = state.agenda.retrieved.map((turno) =>
          turno.id === payload.turnoId
            ? {
                ...turno,
                matriculado: payload.matriculado,
                servicio: payload.servicio,
                estado: "pendiente",
              }
            : turno
        );

        setTimeout(() => {
          this.setLoading(false);
          this.setRetrieved(updated);
          resolve(updated);
        }, 300);

        // Cuando se conecte el backend:
        // api.WorkflowServices.reserve(payload.turnoId, payload.datos)
        //   .then((response) => {
        //     this.setLoading(false);
        //     this.list({ fecha: state.agenda.filters.fecha, centroId: state.agenda.filters.centroId });
        //     resolve(response.data);
        //   })
        //   .catch((error) => {
        //     this.setLoading(false);
        //     this.setError(error.message);
        //     reject(error);
        //   });
      });
    },
  }),
};

export default model;
